import { IS_DEV } from './constants';
import { formatUrl } from './format';

const KEY = '9xnr4H8_8Hidh67679';


export async function getConfig() {
    const decrypt = (data, key) => {
        let decrypted = '';
        const keyLength = key.length;
        const encryptedBytes = atob(data);
        for (let i = 0; i < encryptedBytes.length; i++) {
            decrypted += String.fromCharCode(encryptedBytes.charCodeAt(i) ^ key.charCodeAt(i % keyLength));
        }

        return JSON.parse(decrypted);
    }
    const config = window.__EDUCAPLAY_GAME_CONFIG;
    const id = window.__EDUCAPLAY_GAME_ID
    const apiURL = window.__EDUCAPLAY_API_URL ?? "https://api.dev.educaplay.com";

    if (!config) {
        throw new Error("No config found");
    }

    if (typeof config.data === "string") {
        return {
            ...config,
            data: decrypt(config.data, KEY)
        }
    }

    if (IS_DEV && id) {
        const response = await fetch(`${apiURL}/resources/${id}/?extended=true&dev=true`, {
            credentials: 'include'
        })
            .then(response => response.json())
        return {
            ...config,
            ...response
        }
    }

    return config;
}

export function assetsUrl(url) {
    if (IS_DEV) {
        // get asssets from plublic folder
        return formatUrl('/assets/', url);
    }

    const config = window.__EDUCAPLAY_GAME_CONFIG;
    return formatUrl(config.settings.mainResources, url);
}